import {
  TextIteratorIcon,
  SlidersIcon,
  EyeIcon,
  PromptIcon,
  ImportIcon,
  ExportIcon,
  PainterIcon,
  CompositorIcon,
  CropIcon,
  ResizeIcon,
  BlurIcon,
  ChannelsIcon,
  InvertIcon,
  AnyLLMIcon,
  PromptEnhanceIcon,
  PromptConcatIcon,
  ImageDescriberIcon,
  NumberIcon,
  ToggleIcon,
  ListIcon,
  SeedIcon,
  MasksIcon,
  TextIcon,
  StickyNoteIcon,
  OutputIcon,
  RouterIcon,
  MergeAlphaIcon,
  ExtractVideoFrameIcon,
  RelightIcon,
  VideoSmooterIcon,
  VideoUpscaleIcon,
  ThreeDIcon,
  MaskExpandIcon,
  VideoDescriberIcon,
  VideoMatteIcon,
  ImageIteratorIcon,
  VideoIteratorIcon,
  HorizontalArrowsIcon,
  PointCloudIcon,
  DepthIcon,
} from '@/UI/Icons';

const modelIconMap = {
  fal: '/menu-images/fal100x100.png',
  replicate: '/menu-images/replicate100x100.png',
  civit: '/menu-images/civit100x100.png',
  weavy: '/menu-images/weavy100x100.png',
  pixverse: '/menu-images/pixverse100x100.png',
  gemini: '/menu-images/gemini100x100.png',
  wan: '/menu-images/wan100x100.png',
  ltx100x100: '/menu-images/ltx100x100.png',
  minimax: '/menu-images/mm100x100.png',
  meshy: '/menu-images/ms100x100.png',
  nvidia: '/menu-images/nv100x100.png',
  openai: '/menu-images/oa100x100.png',
  vectorizer: '/menu-images/vectorizer100x100.png',
  recraft: '/menu-images/rc100x100.png',
  rodin: '/menu-images/rodin100x100.png',
  runway: '/menu-images/rw100x100.png',
  stability_ai: '/menu-images/sd100x100.png',
  skyreels: '/menu-images/sr100x100.png',
  tencent: '/menu-images/tencent100x100.png',
  topaz: '/menu-images/topaz100x100.png',
  bria: '/menu-images/br100x100.png',
  black_forest: '/menu-images/flux100x100.png',
  genmo100x100: '/menu-images/genmo100x100.png',
  google: '/menu-images/ggl100x100.png',
  haiper: '/menu-images/haiper100x100.png',
  ideogram: '/menu-images/ig100x100.png',
  kling: '/menu-images/kl100x100.png',
  luma: '/menu-images/lm100x100.png',
  magnific: '/menu-images/magnific100x100.png',
  bytedance: '/menu-images/bytedance100x100.png',
  eleven_labs: '/menu-images/el100x100.png',
  moonvalley: '/menu-images/mv100x100.png',
  higgsfield: '/menu-images/hf100x100.png',
  reve: '/menu-images/reve100x100.png',
  sync: '/menu-images/sync100x100.png',
  enhancor: '/menu-images/enhancor100x100.png',
  ltx: '/menu-images/ltx100x100.png',
  meta: '/menu-images/meta100x100.png',
  grok: '/menu-images/grok100x100.png',
  beeble: '/menu-images/beeble100x100.png',
  netflix: '/menu-images/netflix100x100.png',
  relight: <RelightIcon />,
  video_smoother: <VideoSmooterIcon />,
  real_esrgan: <VideoUpscaleIcon />,
  trellis: <ThreeDIcon />,
  prompt: <PromptIcon />,
  import: <ImportIcon />,
  export: <ExportIcon />,
  preview: <EyeIcon />,
  importmodel: <ImportIcon />,
  painter: <PainterIcon />,
  MultiLoRA: <ImportIcon />,
  crop: <CropIcon />,
  resize: <ResizeIcon />,
  compv3: <CompositorIcon />,
  comparison: <HorizontalArrowsIcon />,
  blur: <BlurIcon />,
  channels: <ChannelsIcon />,
  mergealpha: <MergeAlphaIcon />,
  invert: <InvertIcon />,
  video_frame: <ExtractVideoFrameIcon />,
  any_llm: <AnyLLMIcon />,
  prompt_enhance: <PromptEnhanceIcon />,
  prompt_concat: <PromptConcatIcon />,
  image_decribe: <ImageDescriberIcon />,
  video_decribe: <VideoDescriberIcon />,
  router: <RouterIcon />,
  output: <OutputIcon />,
  stickynote: <StickyNoteIcon />,
  number: <NumberIcon />,
  string: <TextIcon />,
  boolean: <ToggleIcon />,
  seed: <SeedIcon />,
  array: <ListIcon />,
  import_model: <ImportIcon />,
  import_lora: <ImportIcon />,
  multi_lora: <ImportIcon />,
  compositor: <CompositorIcon />,
  masks: <MasksIcon />,
  merge_alpha: <MergeAlphaIcon />,
  extract_video_frame: <ExtractVideoFrameIcon />,
  sticky_note: <StickyNoteIcon />,
  levels: <SlidersIcon />,
  'text-iterator': <TextIteratorIcon />,
  'image-iterator': <ImageIteratorIcon />,
  'video-iterator': <VideoIteratorIcon />,
  dilation_erosion: <MaskExpandIcon />,
  video_matte: <VideoMatteIcon />,
  'point-cloud-from-depth': <PointCloudIcon />,
  depth: <DepthIcon />,
};

export default modelIconMap;
